"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using triple curly braces (`{{{` `}}}`).
 * Matches tags of the form `{{{variable}}}` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello {{{variable}}}';
 * const result = replaceTags(text, { variable: 'world' }, TripleCurlyBraces);
 * console.log(result); // Output: 'Hello world'
 */
var TripleCurlyBraces = {
    name: "Triple Curly Braces",
    openingTag: "{{{",
    closingTag: "}}}",
    tagPattern: /\{\{\{([^}]+)\}\}\}/g,
    tagStartPattern: /^\{\{\{/,
    tagEndPattern: /\}\}\}$/,
};
exports.default = TripleCurlyBraces;
